import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export interface OpeCollateralLimitsResponse {
    max_items: number
}

export default async function getOpeCollateralLimits(
    abortController?: AbortController,
): Promise<OpeCollateralLimitsResponse> {
    try {
        const { data } = await axios.get<OpeCollateralLimitsResponse>(
            `${config.API_BASE_URL}/api/v3/outdoor-power-equipment/limits/`,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
                signal: abortController?.signal,
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to fetch OPE collateral limits: ${axiosError.message}`,
            axiosError,
        )

        throw error
    }
}
